import React from "react";
import { Product } from "../constants";

import HealthCustomerMessage from "./Health/CustomerMessage";
import TravelCustomerMessage from "./Travel/CustomerMessage";
import ServiceCustomerMessage from "./ServiceBot/CustomerMessage";
import HomeCustomerMessage from "./Home/CustomerMessage";
import TermCustomerMessage from "./Term/CustomerMessage";
// import InvestmentCustomerMessage from "./Investment/CustomerMessage";
import InvestmentCustomerMessage from "./Investmentv1/CustomerMessage";
import MotorCustomerMessage from "./Motor/CustomerMessage";
import TwoWheelerCustomerMessage from "./TwoWheeler/CustomerMessage";
import TermLifeCustomerMessage from "./TermLife/CustomerMessage";

export default function CustomerMessage({ messages, regenDoc, productId, isService, isHistoryMessgage, setAgentMsgReplied, roomId, newTermUi, customerName }) {
    return (
        <>
            {productId === Product.Health && !isService ?
                <HealthCustomerMessage
                    messages={messages}
                    regenDoc={regenDoc}
                /> : null}
            {productId === Product.Travel && !isService ?
                <TravelCustomerMessage
                    messages={messages}
                    regenDoc={regenDoc}
                /> : null}
            {productId === Product.Investment && !isService ?
                <InvestmentCustomerMessage
                    messages={messages}
                    regenDoc={regenDoc}
                    customerName={customerName}
                /> : null}
            {isService ?
                <ServiceCustomerMessage
                    messages={messages}
                    regenDoc={regenDoc}
                    isHistoryMessgage={isHistoryMessgage}
                    setAgentMsgReplied={setAgentMsgReplied}
                    roomId={roomId}
                /> : null}
            {productId === Product.Home && !isService ?
                <HomeCustomerMessage
                    messages={messages}
                    regenDoc={regenDoc} />
                : null}
            {productId === Product.Term && !isService && !newTermUi ?
                <TermCustomerMessage
                    messages={messages}
                    regenDoc={regenDoc} />
                : null}
            {(productId === Product.Motor || productId === Product.CommercialVehicle) && !isService ?
                <MotorCustomerMessage
                    messages={messages}
                    regenDoc={regenDoc} />
                : null}
            {productId === Product.Twowheeler && !isService ?
                <TwoWheelerCustomerMessage
                    messages={messages}
                    regenDoc={regenDoc}
                /> : null} 
            {productId === Product.Term && !isService && newTermUi ?
                <TermLifeCustomerMessage
                    messages={messages}
                    regenDoc={regenDoc} 
                    customerName={customerName} />
                : null}               
        </>
    );
}
